/**
 * Default fixture for front desk booking settings.
 * Single source of truth for Figma-matching defaults.
 *
 * Used by:
 * - Server seed during org provisioning
 * - Client-side "Reset to Default" action
 */

// ─── Base Settings ───

export interface FrontDeskBookingSettingsDefaults {
  enabled: boolean;
  default_appointment_status_id: string | null;
}

export const FRONTDESK_BOOKING_DEFAULTS: FrontDeskBookingSettingsDefaults = {
  enabled: true,
  default_appointment_status_id: null,
};

// ─── Patient Field Settings ───
// Same shape as online booking fields — reuse BookingPatientFieldDefault type

import type { BookingPatientFieldDefault } from './online-booking-settings.default';

export const DEFAULT_FRONTDESK_PATIENT_FIELDS: BookingPatientFieldDefault[] = [
  // Required + locked fields
  {
    field_key: 'patient_name',
    enabled: true,
    required: true,
    locked: true,
    section: 'Personal Info',
  },
  {
    field_key: 'mobile_country_code',
    enabled: true,
    required: true,
    locked: true,
    section: 'Contact',
  },
  { field_key: 'mobile_number', enabled: true, required: true, locked: true, section: 'Contact' },

  // Optional fields (disabled by default)
  { field_key: 'email', enabled: false, required: false, locked: false, section: 'Contact' },
  {
    field_key: 'date_of_birth',
    enabled: false,
    required: false,
    locked: false,
    section: 'Personal Info',
  },
  { field_key: 'gender', enabled: false, required: false, locked: false, section: 'Personal Info' },
  {
    field_key: 'address_line_1',
    enabled: false,
    required: false,
    locked: false,
    section: 'Address',
  },
  { field_key: 'city', enabled: false, required: false, locked: false, section: 'Address' },
  { field_key: 'state', enabled: false, required: false, locked: false, section: 'Address' },
  { field_key: 'zip_code', enabled: false, required: false, locked: false, section: 'Address' },
  { field_key: 'id_type', enabled: false, required: false, locked: false, section: 'Other' },
  { field_key: 'id_number', enabled: false, required: false, locked: false, section: 'Other' },
  {
    field_key: 'nationality',
    enabled: false,
    required: false,
    locked: false,
    section: 'Personal Info',
  },
  { field_key: 'notes', enabled: false, required: false, locked: false, section: 'Other' },
];
